import React from 'react';
import {Row, Col} from 'react-bootstrap';
import Button from '@ingka/button';
import DynamicDropdownButton, {
  DropdownItem,
} from '../../DropDownButton/DropDownButton';
import {Filter, GearFill} from "react-bootstrap-icons";

interface ActionButtonsRowProps {
  hasFilterValues: boolean;
  handleClearFilters: () => void;
  exportItems: DropdownItem[];
  offCanvasFiltersLength: number;
  handleShow: () => void;
  handleShowColumnSettings?: () => void;
}

export const ActionButtonsRow: React.FC<ActionButtonsRowProps> = ({
                                                                    hasFilterValues,
                                                                    handleClearFilters,
                                                                    exportItems,
                                                                    offCanvasFiltersLength,
                                                                    handleShow,
                                                                    handleShowColumnSettings
                                                                  }) => (
  <Row>
    <Col>
      <div className="button-container">


        <Button
          size={'small'}
          onClick={handleClearFilters}
          disabled={!hasFilterValues}
        >
          Clear all filters
        </Button>
        <DynamicDropdownButton title="Export" items={exportItems}/>
      </div>
    </Col>
    {offCanvasFiltersLength > 0 && (
      <Col className="text-end">
        <Button
          size={'small'}
          onClick={() => handleShowColumnSettings && handleShowColumnSettings()}
          aria-label="Column settings"
        >
          <GearFill className="w-5 h-5 me-1 mb-1"/> Columns
        </Button>
        <Button size={'small'} onClick={handleShow}>
          <Filter></Filter>
          More filters
        </Button>
      </Col>
    )}
  </Row>
);
